<script lang="ts">
  import DynamicChildrenComponent from '$lib/components/DynamicChildrenComponent/DynamicChildrenComponent.svelte';
  import type { HomePageFAQSectionCustomStylesProps } from './types';

  type $$Props = HomePageFAQSectionCustomStylesProps;
  export let entryId: HomePageFAQSectionCustomStylesProps['entryId'];
  export let content: HomePageFAQSectionCustomStylesProps['content'];
</script>

<div
  data-entry-id={entryId}
  class="HomePageFAQSectionCustomStyles HomePageFAQSectionCustomStyles-{entryId}-box-properties"
>
  <DynamicChildrenComponent children={content} />
</div>

<style lang="scss">
  @use '@squareup/public-web-design-system/dist/styles/xms-fe/core/config/_media_queries' as media;

  :global {
    .HomePageFAQSectionCustomStyles {
      --icon-size: 1.5rem;
      --icon-line-width: 0.3rem;

      > * {
        margin: 0;
      }

      .sq-custom-white-bg {
        --icon-color: var(--color-blue);
        --color-border: var(--color-gray-30);
      }

      .AccordionPlusMinusPartial {
        width: var(--icon-size) !important;
        height: var(--icon-size) !important;
        min-width: var(--icon-size) !important;
        margin-left: var(--icon-size) !important;

        &::before,
        &::after {
          width: var(--icon-size) !important;
          height: var(--icon-line-width) !important;
          background-color: var(--color-link) !important;
        }
      }

      .AccordionListComponent {
        // remove the border from list component and put it in the item
        border-color: transparent !important;

        @include media.until('medium') {
          &:not(:last-child) {
            .AccordionItemComponent:last-child {
              border-bottom: none;
            }
          }
        }
      }

      .AccordionItemComponent {
        padding: var(--space-30);
        padding-right: 0 !important;
        border-color: var(--color-border) !important;

        // Overriding existing contentful h5 class since changing
        // this in the prod entry prior will cause regressions
        --font-size-h5: var(--font-size-h6);
        --line-height-h5: var(--line-height-h6);
        --font-weight-h5: var(--font-weight-h6);

        &:last-child {
          border-bottom: 1px solid var(--color-border);
        }
      }

      @include media.at('medium') {
        display: flex;
        column-gap: var(--space-30);

        .AccordionListComponent .AccordionItemComponent:first-of-type {
          padding-top: var(--space-30);
          border-top: 1px solid var(--color-border-transparent);
        }
      }
    }
  }
</style>
